<template>
  <v-row
    no-gutters
    class="align-center py-1 handleDrag element"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
  >
    <v-col
      cols="auto"
      class="text-truncate text-body-2"
      :class="{ 'pl-2': level > 1 || isRight, 'text--disabled': disabled }"
    >
      {{ attribute ? getAttributeLabel(attribute, label) : label }}
    </v-col>
    <v-col cols="auto" v-if="required" class="pl-2">
      <v-tooltip bottom color="font">
        <template #activator="{ on }">
          <v-icon v-on="on" small>mdi-lock</v-icon>
        </template>
        {{ $i18n.t('dialog.body.requiredAttribute') }}
      </v-tooltip>
    </v-col>
    <v-spacer />
    <v-col cols="auto" v-if="!isRight">
      <dots-menu
        :disabled="disabled"
        font-size="19px"
        :items="computedDotsItems"
        @manageCard="$emit('manageCard', $props)"
        @changeGroupName="$emit('changeGroupName', $props)"
        @changeName="$emit('changeName', $props)"
        @delete="$emit('delete', $props)"
        @setDefaultValue="$emit('setDefaultValue', $props)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'DraggableListsManageCardItem',
  components: {
    DotsMenu,
  },
  props: {
    default_value_policy: {
      type: Object,
      default: () => ({}),
    },
    parentLabel: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    attribute: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    dotsItems: {
      type: Array,
      default: () => [
        {
          name: 'setDefaultValue',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
    },
  },
  data: () => ({}),
  computed: {
    currentLayerDataSourceName: get('layers/currentLayer@data_source_name'),
    attributesMetadata: get('layers/metadata@:currentLayerDataSourceName.attributes_schema.attributes'),
    classes() {
      if (this.isRight) {
        return ['border', 'px-4'];
      }
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : ['pl-6'];
    },
    backgroundColor() {
      return this.level > 1 ? 'rgb(231, 231, 231, 0.5)' : 'white';
    },
    computedDotsItems() {
      if (this.readOnly) {
        return this.dotsItems.map(item => {
          return item.name === 'setDefaultValue'
            ? { ...item, disabled: true, tooltip: this.$i18n.t('sidebar.nonEditableAttributeSetValue') }
            : item;
        });
      }
      return this.dotsItems;
    },
  },
  methods: {
    getAttributeLabel(attribute, label) {
      const attributeMetadata = this.attributesMetadata
        ? this.attributesMetadata.find(att => att.name === attribute)
        : {};
      return attributeMetadata && attributeMetadata.measurement_unit
        ? `${label} [${attributeMetadata.measurement_unit.symbol}]`
        : label;
    },
  },
};
</script>

<style scoped lang="scss">
.element {
  min-height: 38px;
}
.border {
  margin-bottom: 4px;
  @include border();
}
</style>
